<div class="d-flex">
    <div class="p-2 no-padding-left">
        <a (click)="onBack()" class="link" href="javascript:;"><i class='bx bx-arrow-back'></i> Back</a>
    </div>

    
   
</div>
<app-quiz-item [hideAction]="true" [question]="question" *ngFor="let question of questions">

</app-quiz-item>